
import { useState } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";

const images = [
  {
    url: "/lovable-uploads/7ebf536f-4efb-4bcd-873a-e7b04af7ebdc.png",
    title: "BeachBreak"
  },
  {
    url: "/lovable-uploads/8dafdf49-13c5-40e8-be6f-bf78f49946fa.png",
    title: "BeachBreak"
  },
  {
    url: "/lovable-uploads/51d91aa6-46c6-461a-965d-cd4886c6de87.png",
    title: "BeachBreak"
  },
  {
    url: "/lovable-uploads/e8020c8e-5212-4f91-814c-6c596b7459e6.png",
    title: "BeachBreak"
  },
  {
    url: "/lovable-uploads/83ed9b13-2cfa-4bfa-8976-faad42df9c16.png",
    title: "BeachBreak"
  },
  {
    url: "/lovable-uploads/4376b891-95e7-4eef-91de-333c27981d55.png",
    title: "BeachBreak"
  },
  {
    url: "/lovable-uploads/e047d398-9d4f-41e8-aba6-81f7f02ac5ab.png",
    title: "BeachBreak"
  },
  {
    url: "/lovable-uploads/f958528e-ab73-4bd9-8701-eb22c5a0517f.png",
    title: "BeachBreak"
  },
  {
    url: "/lovable-uploads/d5056e6b-524a-4cd3-9e42-731dd13bea30.png",
    title: "BeachBreak"
  },
  {
    url: "/lovable-uploads/0a3cd488-f49e-45fe-ab01-73365eb54de3.png",
    title: "BeachBreak"
  },
  {
    url: "/lovable-uploads/7c442ccb-4d04-40af-88ac-340bc07b5d75.png",
    title: "BeachBreak"
  },
  {
    url: "/lovable-uploads/942e3283-d092-49a4-b67b-4d67d7595d71.png",
    title: "BeachBreak"
  },
  {
    url: "/lovable-uploads/8715afaf-d51c-4dc1-8ecf-c3f6fe9d8766.png",
    title: "BeachBreak"
  },
  {
    url: "/lovable-uploads/31311627-122f-48d3-9441-7ba8ed49b703.png",
    title: "BeachBreak"
  },
  {
    url: "/lovable-uploads/f980c4e0-5e79-4916-9986-1db7061a9e27.png",
    title: "BeachBreak"
  },
  {
    url: "/lovable-uploads/3452040f-6abe-4449-a698-af7bd09d347f.png",
    title: "BeachBreak"
  },
  {
    url: "/lovable-uploads/ea72e725-8228-4ff4-819b-63d70b83306d.png",
    title: "BeachBreak"
  },
  {
    url: "/lovable-uploads/52fbbfbb-57a6-4c4e-8b1c-bf24f8686e1a.png",
    title: "BeachBreak"
  },
  {
    url: "/lovable-uploads/ac0d75ae-f871-49d7-933f-d759a26e9c65.png",
    title: "BeachBreak"
  },
  {
    url: "/lovable-uploads/90aec5a7-aafb-4e7e-9af7-90426b0ab36b.png",
    title: "BeachBreak"
  },
  {
    url: "/lovable-uploads/4e4a3e1e-c803-4456-9a57-466047bfce20.png",
    title: "BeachBreak"
  },
  {
    url: "/lovable-uploads/a77c1952-cd33-42ca-a8e9-632f8d7e3287.png",
    title: "BeachBreak"
  },
  {
    url: "/lovable-uploads/9d7432f8-3df0-484f-88b4-5c59c5322108.png",
    title: "BeachBreak"
  },
  {
    url: "/lovable-uploads/c1660d16-50e4-4063-a62d-b487d0ce41e8.png",
    title: "BeachBreak"
  },
  {
    url: "/lovable-uploads/3575996e-cc25-47a4-9a98-e8d16575f0fd.png",
    title: "BeachBreak"
  },
  {
    url: "/lovable-uploads/a256c7e9-85a7-4786-b8ea-c0518d7575d2.png",
    title: "BeachBreak"
  },
  {
    url: "/lovable-uploads/1d6ae1d3-68cb-4329-a664-8273eb889fe9.png",
    title: "BeachBreak"
  },
  {
    url: "/lovable-uploads/85064af8-7ea2-45d0-8471-716692af1b0d.png",
    title: "BeachBreak"
  },
  {
    url: "/lovable-uploads/24af5680-6ed8-4edc-94b4-a4449142ab0f.png",
    title: "BeachBreak"
  },
  {
    url: "/lovable-uploads/b63609a4-4cb7-48de-8de7-ef330906a24f.png",
    title: "BeachBreak"
  },
  {
    url: "/lovable-uploads/a16798f4-ca2b-4f08-a439-df7fd3551a89.png",
    title: "BeachBreak"
  },
  {
    url: "/lovable-uploads/6577bf30-d408-4649-8827-1a94bd46e026.png",
    title: "BeachBreak"
  },
  {
    url: "/lovable-uploads/59296260-31c9-4fd2-a37d-4e842b9011be.png",
    title: "BeachBreak"
  },
  {
    url: "/lovable-uploads/3991a907-20f5-48ed-ab5a-da9ab4fa13f9.png",
    title: "BeachBreak"
  },
  {
    url: "/lovable-uploads/d92b9168-f3f5-4610-9f60-5dbe0bc77c6c.png",
    title: "BeachBreak"
  },
  {
    url: "/lovable-uploads/7a548089-fb71-435a-b500-b3c87b1788c1.png",
    title: "BeachBreak"
  },
  {
    url: "/lovable-uploads/b41c3910-6f9a-412c-8465-a547a393ad6e.png",
    title: "BeachBreak"
  },
  {
    url: "/lovable-uploads/ba89e8a8-13a8-4132-8217-a8462ff93c8e.png",
    title: "BeachBreak"
  }
];

const Gallery = () => {
  const [selectedImageIndex, setSelectedImageIndex] = useState<number | null>(null);

  const handlePrevious = () => {
    if (selectedImageIndex === null) return;
    setSelectedImageIndex(selectedImageIndex === 0 ? images.length - 1 : selectedImageIndex - 1);
  };

  const handleNext = () => {
    if (selectedImageIndex === null) return;
    setSelectedImageIndex(selectedImageIndex === images.length - 1 ? 0 : selectedImageIndex + 1);
  };

  return (
    <section className="py-16 px-4 bg-background">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl font-bold text-center mb-12">Property Gallery</h2>
        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 xl:grid-cols-8 gap-2">
          {images.map((image, index) => (
            <div
              key={index}
              className="relative h-28 cursor-pointer overflow-hidden rounded-lg fade-in"
              style={{ animationDelay: `${index * 30}ms` }}
              onClick={() => setSelectedImageIndex(index)}
            >
              <img
                src={image.url}
                alt={image.title}
                className="w-full h-full object-cover transition-transform duration-300 hover:scale-110"
              />
              {/* Removed the description div that was here */}
            </div>
          ))}
        </div>
        <p className="text-center mt-4 text-sm text-gray-500">Click on any image to view full size ({images.length} photos)</p>
      </div>

      <Dialog open={selectedImageIndex !== null} onOpenChange={() => setSelectedImageIndex(null)}>
        <DialogContent className="max-w-4xl p-0 overflow-hidden">
          {selectedImageIndex !== null && (
            <div className="relative">
              <img
                src={images[selectedImageIndex].url}
                alt={images[selectedImageIndex].title}
                className="w-full h-auto"
              />
              <div className="absolute inset-0 flex items-center justify-between p-4">
                <Button
                  variant="outline"
                  size="icon"
                  className="rounded-full bg-white/80 hover:bg-white"
                  onClick={(e) => {
                    e.stopPropagation();
                    handlePrevious();
                  }}
                >
                  <ChevronLeft className="h-4 w-4" />
                </Button>
                <Button
                  variant="outline"
                  size="icon"
                  className="rounded-full bg-white/80 hover:bg-white"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleNext();
                  }}
                >
                  <ChevronRight className="h-4 w-4" />
                </Button>
              </div>
              <div className="absolute bottom-0 left-0 right-0 bg-black/60 text-white p-4">
                <p className="text-center text-sm text-white/80">
                  Image {selectedImageIndex + 1} of {images.length}
                </p>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </section>
  );
};

export default Gallery;
